export enum TipType {
  ABSOLUTE = 'absolute',
  RELATIVE = 'relative',
  ANY = 'any',
}
